import { ReactElement, useMemo, useState } from 'react';
import {
  IComponentDropdownWithRedirectFields,
  IFragmentDropdownItemFields,
} from 'types/contentful';
import CTA from 'components/UI/Cta';

export default function DropdownWithRedirect({
  dropdownLabel,
  buttonLabel,
  dropdownItems,
}: IComponentDropdownWithRedirectFields): ReactElement {
  const [selectedSlug, setSelectedSlug] = useState('');

  // Find the selected option based on the slug
  const selectedOption = useMemo<IFragmentDropdownItemFields | undefined>(
    () => dropdownItems.find((item) => item.fields.slug === selectedSlug)?.fields,
    [dropdownItems, selectedSlug]
  );

  // Compute the button label
  const modifiedButtonLabel = useMemo(
    () => buttonLabel.replace('{value}', selectedOption?.label || ''),
    [buttonLabel, selectedOption]
  );

  // Compute the URL and whether to open in a new tab
  const selectedUrl = selectedOption?.slug || '';
  const openInNewTab = selectedUrl.startsWith('http');

  // Accessibility: generate a unique id for the select
  const selectId = `dropdown-with-redirect-${dropdownLabel.replace(/\s+/g, '-').toLowerCase()}`;

  return (
    <div className="ecp-my px-site-component">
      {dropdownLabel && <label htmlFor={selectId}>{dropdownLabel}</label>}
      <div className="my-4 container">
        <select
          id={selectId}
          value={selectedSlug}
          onChange={(e) => setSelectedSlug(e.target.value)}
          className="block container border p-2"
        >
          <option value="">Select {dropdownLabel}</option>
          {dropdownItems.map((item) => (
            <option key={item.sys.id} value={item.fields.slug}>
              {item.fields.label}
            </option>
          ))}
        </select>
      </div>

      {selectedUrl && (
        <div className="my-4 flex justify-end">
          <CTA
            text={modifiedButtonLabel}
            slug={selectedUrl}
            colorScheme="Primary"
            openInNewTab={openInNewTab}
            disabled={!selectedSlug}
          />
        </div>
      )}
    </div>
  );
}
